module.exports = {
    template: '#bookings-template',
    data: function () {
        return {
            viewMode: 'chart',
            date: '',
            items: [],
        };
    },
    computed: {
        bookings: {
            get: function () {
                return this.items;
            },
            set: function (bookings) {
                if (!bookings) {
                    this.items = [];

                    return;
                }

                this.items = bookings.map(function (item) {
                    return {
                        id: item.id,
                        type: item.type,
                        booking_reference: item.booking_reference,
                        location: item.location ? item.location.name : '',
                        start_date: moment(item.start_date).format('Do of MMMM, YYYY'),
                        url: '/wheels/bookings/' + item.booking_reference,
                    };
                }, this);
            },
        },
    },
    methods: {
        show: function (type) {
            this.viewMode = type;
        },
        isVisible: function (type) {
            return this.viewMode === type;
        },
        hasBookings: function () {
            return this.bookings.length > 0;
        },
    },
};



// WEBPACK FOOTER //
// ./resources/scripts/portal/components/bookings/components/Wheels/Bookings.js